import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

const propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  register: PropTypes.func,
};
const defaultProps = {
  disabled: false,
  register: (n) => n,
};

export function InputSocialMedia({ label, disabled, register }) {
  const socialMedia = [
    {
      label: 'Facebook',
      name: 'facebook',
    },
    {
      label: 'Twitter',
      name: 'twitter',
    },
    {
      label: 'Instagram',
      name: 'instagram',
    },
    {
      label: 'Youtube',
      name: 'youtube',
    },
    {
      label: 'LinkedIn',
      name: 'linkedin',
    },
    {
      label: 'Vimeo',
      name: 'vimeo',
    },
  ];

  return (
    <div className="form input address">
      <Row>
        <Col sm={12} xl={3} md={3} className="label-container">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="address-street" className="col-form-label">
            {label}
          </label>
        </Col>
        <Col sm={12} xl={9} md={9} className="field-container">
          {socialMedia.map(({ name, label: smLabel }) => (
            <div
              className={`media-${name} d-flex mb-3 align-items-center align-content-center`}
              key={`sm-${name}`}
            >
              <div className="d-block" style={{ width: '120px' }}>
                <input
                  type="checkbox"
                  id={`media-${name}`}
                  name={`socialMedia[${name}][network]`}
                  {...register(`socialMedia[${name}][network]`)}
                  disabled={disabled}
                  className="me-2"
                  value={name}
                />
                <label htmlFor={`media-${name}`}>{smLabel}</label>
              </div>
              <div className="ms-2 flex-grow-1">
                <input
                  type="url"
                  name={`socialMedia[${name}][location]`}
                  id={`media-${name}-url`}
                  disabled={disabled}
                  className="form-control"
                  {...register(`socialMedia[${name}][location]`)}
                  placeholder={`${smLabel} url`}
                />
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
}

InputSocialMedia.propTypes = propTypes;
InputSocialMedia.defaultProps = defaultProps;
